export const colors = {
  lightblue: "#3F9FBF",
};
